// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_ec","cityChooser__text":"c-j_ee","cityChooser__placeholder":"c-j_ef","cityChooser__buttonIcon":"c-j_eg"};